<template>
  <div v-html="content"></div>
</template>

<script>
  // 富文本内容回显，再重置样式，防止被全局的reset.css污染
  export default {
    name: "RichHtml",
    props: {
      content: String,
    },
  }
</script>

<style scoped>
  /*
  *  以下样式由于全局reset文件被覆盖，所以需要重新定义
  # 完整应参照https://www.w3schools.com/csSref/css_default_values.asp
  */
  
  @media (prefers-color-scheme: dark) {
    body {
      background-color: black;
      color: white;
    }
  }

  ::v-deep html {
    display: block;
  }

  ::v-deep address,
  ::v-deep article,
  ::v-deep aside,
  ::v-deep div,
  ::v-deep footer,
  ::v-deep header,
  ::v-deep hgroup,
  ::v-deep main,
  ::v-deep nav,
  ::v-deep section {
    display: block;
  }

  ::v-deep marquee {
    display: inline-block;
  }

  ::v-deep blockquote {
    display: block;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
  }

  ::v-deep figcaption {
    display: block;
  }

  ::v-deep figure {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
  }

  ::v-deep q {
    display: inline;
  }

  ::v-deep q::before {
    content: open-quote;
  }

  ::v-deep q::after {
    content: close-quote;
  }

  ::v-deep center {
    display: block;
    text-align: -webkit-center;
  }

  ::v-deep hr {
    display: block;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    border-style: inset;
    border-width: 1px;
  }


  ::v-deep body:-webkit-full-page-media {
    background-color: rgb(38, 38, 38);
  }

  ::v-deep video {
    object-fit: contain;
  }

  ::v-deep audio {
    width: 200px;
    height: 25px;
  }


  ::v-deep h1 {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67__qem;
    margin-block-end: 0.67em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }

  ::v-deep :is(article, aside, nav, section) h1 {
    font-size: 1.5em;
    margin-block-start: 0.83__qem;
    margin-block-end: 0.83em;
  }

  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) h1 {
    font-size: 1.17em;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
  }

  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) h1 {
    font-size: 1.00em;
    margin-block-start: 1.33__qem;
    margin-block-end: 1.33em;
  }

  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) h1 {
    font-size: .83em;
    margin-block-start: 1.67__qem;
    margin-block-end: 1.67em;
  }

  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) 
  ::v-deep :is(article, aside, nav, section) h1 {
    font-size: .67em;
    margin-block-start: 2.33__qem;
    margin-block-end: 2.33em;
  }

  ::v-deep h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83__qem;
    margin-block-end: 0.83em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }

  ::v-deep h3 {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }

  ::v-deep h4 {
    display: block;
    margin-block-start: 1.33__qem;
    margin-block-end: 1.33em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }

  ::v-deep h5 {
    display: block;
    font-size: .83em;
    margin-block-start: 1.67__qem;
    margin-block-end: 1.67em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }

  ::v-deep h6 {
    display: block;
    font-size: .67em;
    margin-block-start: 2.33__qem;
    margin-block-end: 2.33em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
  }


  ::v-deep table {
    display: table;
    border-collapse: separate;
    border-spacing: 2px;
    border-color: gray;
    text-indent: initial;
  }

  ::v-deep thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
  }

  ::v-deep tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  ::v-deep tfoot {
    display: table-footer-group;
    vertical-align: middle;
    border-color: inherit;
  }

  ::v-deep table>tr {
    vertical-align: middle;
  }

  ::v-deep col {
    display: table-column;
  }

  ::v-deep colgroup {
    display: table-column-group;
  }

  ::v-deep tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }

  ::v-deep table td,
  ::v-deep table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    height: 32px;
  }
  ::v-deep table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
  }

  



  ::v-deep caption {
    display: table-caption;
    text-align: -webkit-center;
  }


  ::v-deep ul,
  ::v-deep menu,
  ::v-deep dir {
    display: block;
    list-style-type: disc;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px;
  }

  ::v-deep ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px;
  }

  ::v-deep li {
    display: list-item;
    text-align: match-parent;
  }

  ::v-deep ::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    white-space: pre;
    text-transform: none;
  }

  ::v-deep ul ul,
  ::v-deep ol ul {
    list-style-type: circle;
  }

  ::v-deep ol ol ul,
  ::v-deep ol ul ul,
  ::v-deep ul ol ul,
  ::v-deep ul ul ul {
    list-style-type: square;
  }

  ::v-deep dd {
    display: block;
    margin-inline-start: 40px;
  }

  ::v-deep dl {
    display: block;
    margin-block-start: 1__qem;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  ::v-deep dt {
    display: block;
  }

  ::v-deep ol ul,
  ::v-deep ul ol,
  ::v-deep ul ul,
  ::v-deep ol ol {
    margin-block-start: 0;
    margin-block-end: 0;
  }


  ::v-deep form {
    display: block;
    margin-top: 0__qem;
  }

  ::v-deep label {
    cursor: default;
  }

  ::v-deep legend {
    display: block;
    padding-inline-start: 2px;
    padding-inline-end: 2px;
    border: none;
  }

  ::v-deep fieldset {
    display: block;
    margin-inline-start: 2px;
    margin-inline-end: 2px;
    padding-block-start: 0.35em;
    padding-inline-start: 0.75em;
    padding-inline-end: 0.75em;
    padding-block-end: 0.625em;
    border: 2px groove ThreeDFace;
    min-width: min-content;
  }

  ::v-deep button {
    appearance: auto;
  }

  ::v-deep input,
  ::v-deep textarea,
  ::v-deep select,
  ::v-deep button,
  ::v-deep meter,
  ::v-deep progress {
    writing-mode: horizontal-tb !important;
  }

  @media(prefers-color-scheme: dark) {
    input {
      background-color: transparent;
    }
  }

  ::v-deep input::-webkit-textfield-decoration-container {
    display: flex;
    align-items: center;
    content: none !important;
  }

  ::v-deep select {
    border-radius: 5px;
  }

  ::v-deep ::placeholder {
    -webkit-text-security: none;
    color: darkGray;
    pointer-events: none !important;
  }

  ::v-deep input::placeholder {
    white-space: pre;
    word-wrap: normal;
    overflow: hidden;
    line-height: initial !important;
  }

  ::v-deep input:is([type="hidden"], [type="image"], [type="file"]) {
    appearance: initial;
    padding: initial;
    background-color: initial;
    border: initial;
  }

  ::v-deep input[type="file"] {
    align-items: baseline;
    color: inherit;
    text-align: start !important;
  }

  ::v-deep input:-webkit-autofill-and-obscured {
    -webkit-text-security: disc !important;
  }

  ::v-deep input:-webkit-autofill-strong-password {
    user-select: none !important;
  }

  ::v-deep input:is([type="button"], [type="submit"], [type="reset"]) {
    white-space: pre;
  }

  ::v-deep input[type="file"]::file-selector-button {
    white-space: nowrap;
    margin: 0;
    font-size: inherit;
  }

  ::v-deep input[type="range"] {
    padding: initial;
    border: initial;
    margin: 2px;
    color: #909090;
  }

  ::v-deep input[type="range"]::-webkit-slider-runnable-track {
    flex: 1;
    align-self: center;

    box-sizing: border-box;
    display: block;
  }

  ::v-deep input[type="range"]::-webkit-media-slider-thumb {
    background-color: white;
    border: 1px solid rgb(66, 66, 66);
    padding: 0px;
  }

  ::v-deep input:disabled,
  textarea:disabled {
    opacity: 0.4;
  }

  ::v-deep input[readonly],
  textarea[readonly] {
    border-color: rgb(188, 188, 188);
  }
  ::v-deep area,
  ::v-deep param {
    display: none;
  }
  ::v-deep meter {
	    appearance: auto;
	    box-sizing: border-box;
	    display: inline-block;
	    height: 1em;
	    width: 5em;
	    vertical-align: -0.2em;
	}
	
	
	::v-deep progress {
	    appearance: auto;
	    box-sizing: border-box;
	    display: inline-block;
	    height: 1em;
	    width: 10em;
	    vertical-align: -0.2em;
	}
	
	::v-deep progress::-webkit-progress-inner-element {
	    box-sizing: inherit;
	    height: 100%;
	    width: 100%;
	}
	
	::v-deep progress::-webkit-progress-bar {
	    background-color: gray;
	    height: 100%;
	    width: 100%;
	    box-sizing: border-box;
	}
	
	::v-deep progress::-webkit-progress-value {
	    background-color: green;
	    height: 100%;
	    width: 50%; 
	    box-sizing: border-box;
	}
	
	
	::v-deep u, 
  ::v-deep ins {
	    text-decoration: underline;
	}
	
	::v-deep strong, 
  ::v-deep b {
	    font-weight: bold;
	}
	
	::v-deep i, 
  ::v-deep cite, 
  ::v-deep em, 
  ::v-deep var, 
  ::v-deep address, 
  ::v-deep dfn {
	    font-style: italic;
	}
	
	::v-deep tt, 
  ::v-deep code, 
  ::v-deep kbd, 
  ::v-deep samp {
	    font-family: monospace;
	}
	
	::v-deep pre, 
  ::v-deep xmp, 
  ::v-deep plaintext, 
  ::v-deep listing {
	    display: block;
	    font-family: monospace;
	    white-space: pre;
	    margin: 1__qem 0;
	}
	
	::v-deep mark {
	    background-color: yellow;
	    color: black;
	}
	
	::v-deep big {
	    font-size: larger;
	}
	
	::v-deep small {
	    font-size: smaller;
	}
	
	::v-deep s, 
  ::v-deep strike,
  ::v-deep del {
	    text-decoration: line-through;
	}
	
	::v-deep sub {
	    vertical-align: sub;
	    font-size: smaller;
	}
	
	::v-deep sup {
	    vertical-align: super;
	    font-size: smaller;
	}
	
	::v-deep nobr {
	    white-space: nowrap;
	}
  ::v-deep a:any-link {
	    color: -webkit-link;
	    text-decoration: underline;
	    cursor: auto;
	}
	
	::v-deep a:any-link:active {
	    color: -webkit-activelink;
	}
	
	
	::v-deep ruby, 
  ::v-deep rt {
	    text-indent: 0; 
	}
	
	::v-deep rt {
	    line-height: normal;
	    text-emphasis: none;
	}
	
	::v-deep ruby > rt {
	    display: block;
	    font-size: -webkit-ruby-text;
	    text-align: start;
	}
	
	::v-deep ruby > rp {
	    display: none;
	}
	
	
	::v-deep noframes {
	    display: none;
	}
	
	::v-deep frameset, 
  ::v-deep frame {
	    display: block;
	}
	
	::v-deep frameset {
	    border-color: inherit;
	}
	
	::v-deep iframe {
	    border: 2px inset;
	}
	
	::v-deep details {
	    display: block;
	}
	
	::v-deep summary {
	    display: block;
	}
	
	::v-deep summary::-webkit-details-marker {
	    display: inline-block;
	    width: 0.66em;
	    height: 0.66em;
	    margin-right: 0.4em;
	}
	
	::v-deep template {
	    display: none;
	}
	
	::v-deep bdi, output {
	    unicode-bidi: isolate;
	}
	
	::v-deep bdo {
	    unicode-bidi: bidi-override;
	}
	
	::v-deep slot {
	    display: contents;
	}

::v-deep  *{box-sizing:border-box;margin:0;outline:none;padding:0}
::v-deep  blockquote,
::v-deep  li,
::v-deep  p,
::v-deep  td,
::v-deep  th{line-height:1.5}
::v-deep  p{margin:15px 0}
::v-deep  h1
::v-deep  h2,
::v-deep  h3,
::v-deep  h4,
::v-deep  h5{margin:20px 0}
::v-deep  img{cursor:default;display:inline!important;max-width:100%;min-height:20px;min-width:20px}
::v-deep  blockquote{background-color:var(--w-e-textarea-slight-bg-color);border-left:8px solid var(--w-e-textarea-selected-border-color);display:block;font-size:100%;line-height:1.5;margin:10px 0;padding:10px}
::v-deep .w-e-textarea-divider{border-radius:3px;margin:20px auto;padding:20px}
::v-deep  pre>code{background-color:var(--w-e-textarea-slight-bg-color);border:1px solid var(--w-e-textarea-slight-border-color);border-radius:4px 4px;display:block;font-size:14px;padding:10px;text-indent:0}
::v-deep  .w-e-image-container{display:inline-block;margin:0 10px}
::v-deep  .w-e-image-container:hover{box-shadow:0 0 0 2px var(--w-e-textarea-selected-border-color)}
::v-deep  ol,
::v-deep  ul{padding-left:20px}
::v-deep  li{line-height:inherit;margin:10px 0}
::v-deep  .table-container{border:1px dashed var(--w-e-textarea-border-color);border-radius:5px;margin-top:10px;overflow-x:auto;padding:10px;width:100%}
::v-deep  table{border-collapse:collapse}
::v-deep  table td,
::v-deep  table th{border:1px solid var(--w-e-textarea-border-color);line-height:1.5;min-width:30px;padding:3px 5px;text-align:left}
::v-deep  table th{background-color:var(--w-e-textarea-slight-bg-color);font-weight:700;text-align:center}
::v-deep .w-e-textarea-video-container{background-image:linear-gradient(45deg,#eee 25%,transparent 0,transparent 75%,#eee 0,#eee),linear-gradient(45deg,#eee 25%,#fff 0,#fff 75%,#eee 0,#eee);background-position:0 0,10px 10px;background-size:20px 20px;border:1px dashed var(--w-e-textarea-border-color);border-radius:5px;margin:10px auto 0;padding:10px 0;text-align:center}
  ::v-deep pre>code{word-wrap:normal;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;-webkit-hyphens:none;hyphens:none;line-height:1.5;margin:.5em 0;overflow:auto;padding:1em;-moz-tab-size:4;-o-tab-size:4;tab-size:4;text-align:left;text-shadow:0 1px #fff;white-space:pre;word-break:normal;word-spacing:normal}
  ::v-deep pre>code .token.cdata,
  ::v-deep pre>code .token.comment,
  ::v-deep pre>code .token.doctype,
  ::v-deep pre>code .token.prolog{color:#708090}
  ::v-deep pre>code .token.punctuation{color:#999}
  ::v-deep pre>code .token.namespace{opacity:.7}
  ::v-deep pre>code .token.boolean,
  ::v-deep pre>code .token.constant,
  ::v-deep pre>code .token.deleted,
  ::v-deep pre>code .token.number,
  ::v-deep pre>code .token.property,
  ::v-deep pre>code .token.symbol,
  ::v-deep pre>code .token.tag{color:#905}
  ::v-deep pre>code .token.attr-name,
  ::v-deep pre>code .token.builtin,
  ::v-deep pre>code .token.char,
  ::v-deep pre>code .token.inserted,
  ::v-deep pre>code .token.selector,
  ::v-deep pre>code .token.string{color:#690}
  ::v-deep pre>code .language-css .token.string,
  ::v-deep pre>code .style .token.string,
  ::v-deep pre>code .token.entity,
  ::v-deep pre>code .token.operator,
  ::v-deep pre>code .token.url{color:#9a6e3a}
  ::v-deep pre>code .token.atrule,
  ::v-deep pre>code .token.attr-value,
  ::v-deep pre>code .token.keyword{color:#07a}
  ::v-deep pre>code .token.class-name,
  ::v-deep pre>code .token.function{color:#dd4a68}
  ::v-deep pre>code .token.important,
  ::v-deep pre>code .token.regex,
  ::v-deep pre>code .token.variable{color:#e90}
  ::v-deep pre>code .token.bold,
  ::v-deep pre>code .token.important{font-weight:700}
  ::v-deep pre>code .token.italic{font-style:italic}
  ::v-deep pre>code .token.entity{cursor:help}

/* ::v-deep i, 
::v-deep cite, 
::v-deep em, 
::v-deep var, 
::v-deep address, 
::v-deep dfn {
	    font-style: italic;
	} */
</style>